import { render, staticRenderFns } from "./popArea.vue?vue&type=template&id=3e4ba4f0&scoped=true"
import script from "./popArea.vue?vue&type=script&lang=js"
export * from "./popArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4ba4f0",
  null
  
)

export default component.exports